module.exports = __webpack_public_path__ + "static/img/login_part02_img03.12059a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_part02_img03.png
// module id = J/iW
// module chunks = 1